module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="reviewer-form-row reviewer-row ';
 if (status == 'DELETED') { 
__p+=' deprecated-header ';
 } 
__p+='">\n    <div class="form">\n        <div class="form-group col-md-4 col-xs-4" id="organizations"></div>\n\n        <div class="form-group col-md-4 col-xs-4" id="persons"></div>\n\n        <div class="form-group col-md-1 col-xs-1">\n            <div class="checkbox">\n                <label>\n                    <input type="checkbox" id="mandatory" '+
((__t=( mandatory ))==null?'':__t)+
' > Mandatory\n                </label>\n            </div>\n        </div>\n        <div class="form-group col-md-3 col-xs-3">\n        ';
 if (showRemove) { 
__p+='\n            <div class="checkbox">\n                <span class="remove-reviewer dotted-link edit-buttons right-buttons" style="color: red;">- '+
((__t=( removeButtonText ))==null?'':__t)+
'</span>\n            </div>\n        ';
 } 
__p+='\n        </div>\n    </div>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/review/reviewer-form.html
// module id = 316
// module chunks = 0